<template>
  <div class="terms">
    <h1>{{$t('terms')}} </h1>
<b><u>{{$t('terms')}}</u></b><br/>
<br/>
<b>{{$t('terms01')}}</b>
<ol>
<li>{{$t('terms02')}}</li>
<li>{{$t('terms03')}}</li>
</ol>    
<br/>
<b>{{$t('terms04')}}</b><br/>
<ol>
<li>{{$t('terms05')}}</li>
<li>{{$t('terms06')}}</li>
<li>{{$t('terms07')}}</li>
<li>{{$t('terms08')}}</li>
</ol>
<br/>
<b>{{$t('terms09')}}</b><br/>
<ol>
<li>{{$t('terms10')}}</li>
<li>{{$t('terms11')}}</li>
<li>{{$t('terms12')}}</li>
</ol>
<br/>
<b>{{$t('terms13')}}</b><br/>
<ol>
<li>{{$t('terms14')}}</li>
<li>{{$t('terms15')}}</li>
<li>{{$t('terms16')}}</li>
<li>{{$t('terms17')}}</li>
<li>{{$t('terms18')}}</li>
<li>{{$t('terms19')}}</li>
<li>{{$t('terms20')}}</li>
</ol>
<br/>
<b>{{$t('terms21')}}</b><br/>
<ol>
<li>{{$t('terms22')}}</li>
<li>{{$t('terms23')}}</li>
</ol>
<br/>
<b>{{$t('terms24')}}</b><br/>
<ol>
<li>{{$t('terms25')}}</li>
<li>{{$t('terms26')}}</li>
<li>{{$t('terms27')}}</li>
<li>{{$t('terms28')}}</li>
<li>{{$t('terms29')}}</li>
<li>{{$t('terms30')}}</li>
<li>{{$t('terms31')}}</li>
<br/>
<p>{{$t('terms32')}}</p>
<ul>
<li>{{$t('terms33')}}</li>
<li>{{$t('terms34')}}</li>
<li>{{$t('terms35')}}</li>
<li>{{$t('terms36')}}</li>
<li>{{$t('terms37')}}</li>
<li>{{$t('terms38')}}</li>
<li>{{$t('terms39')}}</li>
<li>{{$t('terms40')}}</li>
<li>{{$t('terms41')}}</li>
<li>{{$t('terms42')}}</li>
<li>{{$t('terms43')}}</li>
<li>{{$t('terms44')}}</li>
</ul>
</ol>
<p>{{$t('terms45')}}</p>
<br/>
<b>{{$t('terms46')}}</b><br/>
<ol>
<li>{{$t('terms47')}}</li>
<li>{{$t('terms48')}}</li>
<li>{{$t('terms49')}}</li>
<li>{{$t('terms50')}}</li>
<li>{{$t('terms51')}}</li>
</ol>
<br/>
<b>{{$t('terms52')}}</b><br/>
<ol>
<li>{{$t('terms53')}}</li>
<li>{{$t('terms54')}}</li>
</ol>
</div>
</template>

<script>

export default {
  components: { }
};
</script>

<style scoped>
.terms {
  text-align: left;
  padding: 1rem;
  padding-top: 40px;
}
</style>
